import { useState } from "react";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import GenericCrudPanel from "../../components/common/crud/GenericCrudPanel";

const HR_BASE = `${process.env.REACT_APP_BACKEND_API_URL}/hr`;

const MODULE = {
  key: "assettype",
  title: "Asset Types",
  endpoint: "/assettype/",
  fields: [
    { name: "name", label: "Name", required: true },
    { name: "code_prefix", label: "Prefix", required: true },
  ],
  columns: [
    { name: "Name", selector: (row) => row.name || "-", sortable: true },
    { name: "Prefix", selector: (row) => row.code_prefix || "-", sortable: true },
  ],
  initialForm: { name: "", code_prefix: "" },
};

function AssetTypeMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");

  const handleDataFromTopNavBar = (permissiondata) => {
    setDataFromTopNavBar(permissiondata);
  };

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AssetTypeMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"}>
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-sm-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ? <span><i className="fa fa-chevron-left mx-1"></i></span> : <span><i className="fa fa-chevron-right mx-1"></i></span>}
              </Button>
              <span className="page-header-text">Asset Type Master</span>
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30 }}>
          <GenericCrudPanel module={MODULE} baseUrl={HR_BASE} />
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default AssetTypeMaster;
